var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatPsd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0a.5.5 0 0 1 .492.41L14 .5l-.001 5.499L19.5 6a.5.5 0 0 1 .492.41L20 6.5a.5.5 0 0 1-.41.492L19.5 7h-6a.5.5 0 0 1-.492-.41L13 6.5v-6a.5.5 0 0 1 .5-.5ZM9.5 13c.927 0 1.68.758 1.737 1.711a.5.5 0 1 1-.998.06C10.213 14.332 9.883 14 9.5 14c-.402 0-.742.363-.742.825 0 .314.107.458.337.557.048.02.1.038.157.054l.142.032.471.095c.154.033.293.074.43.133.58.248.945.738.945 1.477 0 1.002-.77 1.827-1.74 1.827-.929 0-1.683-.759-1.74-1.712a.5.5 0 0 1 1-.06c.025.44.355.772.74.772.402 0 .74-.362.74-.827 0-.315-.107-.46-.337-.557a1.35 1.35 0 0 0-.248-.075l-.526-.106a2.333 2.333 0 0 1-.427-.134c-.58-.248-.944-.738-.944-1.476 0-1 .773-1.825 1.742-1.825Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0H.5a.5.5 0 0 0-.5.5v23a.5.5 0 0 0 .5.5h19a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.146-.354l-6-6A.5.5 0 0 0 13.5 0Zm-.208.999 5.707 5.707v16.293h-18v-22h12.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 13a1.75 1.75 0 0 1 .143 3.494l-.143.006-.739-.001.009 1.998a.5.5 0 0 1-.408.494l-.09.008a.5.5 0 0 1-.494-.408l-.008-.09-.01-2.403L3 16l.002-.046.008-.05L3 13.502a.5.5 0 0 1 .41-.494L3.5 13h1.25Zm-.743 2.499.743.001a.75.75 0 0 0 .102-1.493L4.75 14l-.749-.001.006 1.5ZM14.5 13h-1a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h1c1.454 0 2.5-1.31 2.5-3s-1.046-3-2.5-3Zm-.501 4.999v-4L14.5 14c.846 0 1.5.82 1.5 2 0 1.18-.654 2-1.5 2l-.501-.001Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatPsd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/format-psd.3fc8ed93ed43f03c78a9966d97cbd745.svg";